export default __webpack_public_path__ + "static/media/excel.d69d94da.png";